import styled from '@emotion/styled';
import Dynamic from '@base/Dynamic/Dynamic';
import Loader from '@educator/Composite/QuestionCreation/Loader';
import useLanding from './useLanding';
import { WIDTH_MAX, WIDTH_MIN } from '../../constants';
import Navigation from '../Navigation/Navigation';

const Modals = Dynamic(() => import('@cont/Quiz/Taking/Modals'));
const ObjectiveQuestionView = Dynamic(() =>
  import('@cont/Quiz/Taking/Objective/QuestionView')
);
const SubjectiveQuestionView = Dynamic(() =>
  import('@cont/Quiz/Taking/Subjective/QuestionView')
);

const Wrapper = styled.div`
  min-width: ${WIDTH_MIN}px;
  max-width: ${WIDTH_MAX}px;
  height: 100vh;
  margin: auto;
  display: grid;
  grid-template-columns: 70% 30%;
  background-color: var(--color-base-0);
`;

const QuizContent = ({ isSubjective }) => {
  // For proctored quizzes, show a loader until proctoring has started -
  // unless the session has already reached a terminal state.
  // const shouldShowLoader =
  //   isProctored &&
  //   status !== 'running' &&
  //   !hasStartedSuccessfully &&
  //   !TERMINAL_PROCTOR_STATUSES.includes(status);

  // if (shouldShowLoader) {
  //   return (
  //     <LoadingWrapper>
  //       <Loader />
  //       <LoadingMessage>Starting proctoring...</LoadingMessage>
  //     </LoadingWrapper>
  //   );
  // }

  const renderQuestionView = () => {
    if (isSubjective) {
      return <SubjectiveQuestionView />;
    }

    return <ObjectiveQuestionView />;
  };

  return (
    <>
      <Wrapper>
        <div>{renderQuestionView()}</div>
        <Navigation />
      </Wrapper>
      <Modals />
    </>
  );
};

const TakingLanding = () => {
  const { isSubjective, hasFetchedQuizQuestions } = useLanding();

  if (!hasFetchedQuizQuestions) {
    return <Loader />;
  }

  return <QuizContent isSubjective={isSubjective} />;
};

export default TakingLanding;
